<template>
  <div v-if="loading" class="loader">
    <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner>
  </div>
  <div v-else class="row">
    <div
      class="col-lg-4 col-md-12 col-sm-12 card-devices"
      style="align-items: center; text-align: center;"
    >
      <span style="font-size: 24px;">{{
        $t('reports.deviceAnalysis.deviceTitle')
      }}</span
      ><br />
      <span>{{ $t('reports.deviceAnalysis.deviceSubText') }}</span>
      <div class="align-card-center" style="margin-top: 70px;">
        <highcharts :options="chartOptionsDevice"></highcharts>
      </div>
    </div>

    <div
      class="col-lg-4 col-md-12 col-sm-12 card-devices"
      style="align-items: center; text-align: center;"
    >
      <span style="font-size: 24px;">{{
        $t('reports.deviceAnalysis.soTitle')
      }}</span>
      <br />
      <span>{{ $t('reports.deviceAnalysis.soSubText') }}</span>
      <div style="margin-top: 25px; margin-bottom: 25px;">
        <b-form-select
          v-model="osSelector"
          :options="optionsSO"
          style="width: 200px;"
        ></b-form-select>
      </div>
      <div
        class="align-card-center"
        style="margin-top: 25px; margin-bottom: 25px;"
      >
        <highcharts :options="chartOptionsOS"></highcharts>
      </div>
    </div>

    <div
      class="col-lg-4 col-md-12 col-sm-12 card-devices"
      style="align-items: center; text-align: center;"
    >
      <span style="font-size: 24px;">{{
        $t('reports.deviceAnalysis.browserTitle')
      }}</span>
      <br />
      <span>{{ $t('reports.deviceAnalysis.browserSubText') }}</span>
      <div style="margin-top: 25px; margin-bottom: 25px;">
        <b-form-select
          v-model="browserSelector"
          :options="optionsBrowser"
          style="width: 200px;"
        ></b-form-select>
      </div>
      <div class="align-card-center">
        <highcharts :options="chartOptionsBrowser"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  data: () => ({
    loading: true,
    chartOptionsDevice: {},
    chartOptionsBrowser: {},
    chartOptionsOS: {},
    browserSelector: null,
    osSelector: null,
    optionsBrowser: [],
    optionsSO: [],
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    browserSelector: async function watchBrowserSelector(value) {
      const response = await api.get('/reports/browser/details', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          groupId: this.actionGroupData._id,
          metric: this.myMetric ? this.myMetric : null,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          selected: value,
        },
      });

      const mobile = response.data.dataMobile.mobile;
      const mobileQty = response.data.dataMobile.mobileQty;

      const desktop = response.data.dataDesktop.desktop;
      const desktopQty = response.data.dataDesktop.desktopQty;

      const tablet = response.data.dataTablet.tablet;
      const tabletQty = response.data.dataTablet.tabletQty;

      this.chartOptionsBrowser.series[0].data = [];

      if (value === 'mobile') {
        for (let i = 0; i < mobile.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: mobile[i],
            y: mobileQty[i],
          });
        }
      }

      if (value === 'desktop') {
        for (let i = 0; i < desktop.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: desktop[i],
            y: desktopQty[i],
          });
        }
      }

      if (value === 'tablet') {
        for (let i = 0; i < tablet.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: tablet[i],
            y: tabletQty[i],
          });
        }
      }

      if (value === 'all') {
        this.getAllData();
      }
    },

    osSelector: async function watchBrowserSelector(value) {
      const response = await api.get('/reports/so/details', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          groupId: this.actionGroupData._id,
          metric: this.myMetric ? this.myMetric : null,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          selected: value,
        },
      });

      const mobile = response.data.dataMobile.mobile;
      const mobileQty = response.data.dataMobile.mobileQty;

      const desktop = response.data.dataDesktop.desktop;
      const desktopQty = response.data.dataDesktop.desktopQty;

      const tablet = response.data.dataTablet.tablet;
      const tabletQty = response.data.dataTablet.tabletQty;

      this.chartOptionsOS.series[0].data = [];

      if (value === 'mobile') {
        for (let i = 0; i < mobile.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: mobile[i],
            y: mobileQty[i],
          });
        }
      }

      if (value === 'desktop') {
        for (let i = 0; i < desktop.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: desktop[i],
            y: desktopQty[i],
          });
        }
      }

      if (value === 'tablet') {
        for (let i = 0; i < tablet.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: tablet[i],
            y: tabletQty[i],
          });
        }
      }

      if (value === 'all') {
        this.getAllData();
      }
    },

    calendarDates: function watchCalendarDates() {
      this.getDeviceInfo();
    },

    myActionId: function watchMyActionId() {
      this.getDeviceInfo();
    },

    myActionsIds: function watchMyActionsIds() {
      this.getDeviceInfo();
    },

    actionGroupData: function watchActionGroup() {
      this.getDeviceInfo();
    },

    myIh1: function watchMyIh1() {
      this.getDeviceInfo();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getDeviceInfo();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getDeviceInfo();
    },

    myIh2: function watchMyIh2() {
      this.getDeviceInfo();
    },

    myMetric: function watchMyMetric() {
      this.getDeviceInfo();
    },

    'indicatorData.value': function watchIndicatorData() {
      this.getDeviceInfo();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getDeviceInfo();
    },
  },

  methods: {
    async getAllData() {
      const response = await api.get('/reports/device', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          groupId: this.actionGroupData._id,
          metric: this.myMetric ? this.myMetric : null,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      const devices = response.data.dataDevices.devices;
      const devicesQty = response.data.dataDevices.devicesQty;

      const browser = response.data.dataBrowser.browser;
      const browserQty = response.data.dataBrowser.browserQty;

      const operationalSystem = response.data.dataSO.operationalSystem;
      const operationalSystemQty = response.data.dataSO.operationalSystemQty;

      this.chartOptionsDevice.series[0].data = [];
      this.chartOptionsBrowser.series[0].data = [];
      this.chartOptionsOS.series[0].data = [];

      for (let i = 0; i < devices.length; i += 1) {
        this.chartOptionsDevice.series[0].data.push({
          name: devices[i],
          y: devicesQty[i],
        });
      }

      for (let i = 0; i < browser.length; i += 1) {
        this.chartOptionsBrowser.series[0].data.push({
          name: browser[i],
          y: browserQty[i],
        });
      }

      for (let i = 0; i < operationalSystem.length; i += 1) {
        this.chartOptionsOS.series[0].data.push({
          name: operationalSystem[i],
          y: operationalSystemQty[i],
        });
      }
    },

    async getDeviceInfo() {
      this.loading = true;

      await this.getAllData();

      this.loading = false;
    },

    translateSelect() {
      this.optionsBrowser = [
        { value: null, text: this.$t('reports.deviceAnalysis.selectDevice') },
        { value: 'desktop', text: 'Desktop' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'tablet', text: 'Tablet' },
        { value: 'all', text: this.$t('reports.deviceAnalysis.all') },
      ];

      this.optionsSO = [
        { value: null, text: this.$t('reports.deviceAnalysis.selectDevice') },
        { value: 'desktop', text: 'Desktop' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'tablet', text: 'Tablet' },
        { value: 'all', text: this.$t('reports.deviceAnalysis.all') },
      ];
    },
  },

  mounted() {
    EventBus.$on('changedLanguage', () => {
      this.translateSelect();
    });
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.loading = true;

    this.translateSelect();

    this.getDeviceInfo();

    this.chartOptionsDevice = {
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
            format: '{point.percentage:.1f}%',
          },
          showInLegend: true,
        },
      },
      colors: [
        '#22CD70',
        '#17a2b8',
        '#E84C3E',
        '#F3C102',
        '#ff6699',
        '#33cc33',
      ],
      series: [
        {
          innerSize: '50%',
          name: this.$t('reports.deviceAnalysis.qty'),
          data: [],
        },
      ],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        style: {
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
          fontSize: '12px',
        },
      },
    };

    this.chartOptionsOS = {
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
            format: '{point.percentage:.1f}%',
          },
          showInLegend: true,
        },
      },
      colors: [
        '#22CD70',
        '#17a2b8',
        '#E84C3E',
        '#F3C102',
        '#ff6699',
        '#33cc33',
      ],
      series: [
        {
          innerSize: '50%',
          name: this.$t('reports.deviceAnalysis.qty'),
          data: [],
        },
      ],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        style: {
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
          fontSize: '12px',
        },
      },
    };

    this.chartOptionsBrowser = {
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
            format: '{point.percentage:.1f}%',
          },
          showInLegend: true,
        },
      },
      colors: [
        '#22CD70',
        '#17a2b8',
        '#E84C3E',
        '#F3C102',
        '#ff6699',
        '#33cc33',
      ],
      series: [
        {
          innerSize: '50%',
          name: this.$t('reports.deviceAnalysis.qty'),
          data: [],
        },
      ],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        style: {
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
          fontSize: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss">
.card-devices {
  padding: 0;
  border: 8px solid #f1f1f1;
  margin-top: -18px;
  margin-bottom: -16px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.align-card-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/device-analysis/index.vue